import { defineMessages } from "react-intl";

export default defineMessages({
  companyName: {
    id: "globals.companyName",
    defaultMessage: "Ring Twice",
  },
  companyLegalName: {
    id: "globals.companyLegalName",
    defaultMessage: "ListMinut SA",
  },
  companyIban: {
    id: "globals.companyIban",
    defaultMessage: "BE 0503.832.450",
  },
  companyStartingYear: {
    id: "globals.companyStartingYear",
    defaultMessage: "2013",
  },
});
